import React, { useState } from "react";
import { AUCTIONS } from "../../api/auctiongate.js";

export default function VinSearchBar({
  initialValue = "",
  initialAuction = "copart",
  onSubmit,
  placeholder = "Enter VIN or Lot number…",
}) {
  const [value, setValue] = useState(initialValue);
  const [auction, setAuction] = useState(initialAuction);

  const handle = (e) => {
    e.preventDefault();
    const v = value.trim();
    if (!v) return;
    onSubmit?.({ query: v, auction });
  };

  return (
    <form className="vin-bar" onSubmit={handle}>
      <div className="vin-bar__inner">
        <span className="vin-bar__label">Search</span>
        <select
          value={auction}
          onChange={(e) => setAuction(e.target.value)}
          style={{
            padding: "10px 12px",
            border: "1px solid var(--color-border-input)",
            borderRadius: "var(--radius-btn)",
            background: "#fff",
            minWidth: 170,
          }}
        >
          {AUCTIONS.map((a) => (
            <option key={a.value} value={a.value}>
              {a.label}
            </option>
          ))}
        </select>
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          autoComplete="off"
          spellCheck={false}
        />
        <button type="submit" className="btn btn-accent">
          Search
        </button>
      </div>
    </form>
  );
}
